document.addEventListener("DOMContentLoaded", function () {

    console.log("audit_record");

    $('.select2').select2({
        width: '100%',
        placeholder: 'Selecciona una o más auditorías'
    });

    const maxFileSizeMB = 2;

    document.querySelectorAll('input[type="file"]').forEach((input) => {
        input.addEventListener("change", function () {
            const file = this.files[0];
            if (file) {
                const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];
                if (!allowedTypes.includes(file.type)) {
                    Swal.fire('Error', "Tipo de archivo no permitido. Solo PDF, JPG y PNG.", 'error')
                    this.value = "";
                    return;
                }

                if (file.size > maxFileSizeMB * 1024 * 1024) {
                    Swal.fire('Error', `El archivo excede el tamaño máximo de ${maxFileSizeMB}MB.`, 'error')
                    this.value = "";
                }
            }
        });
    });


    const select_audit_record_client_id = document.querySelector("#audit_record_client_id");
    if(select_audit_record_client_id) {
        $(document).on('change', '#audit_record_client_id', function(e) {
        // document.getElementById("audit_record_client_id").addEventListener("change", function () {
            document.getElementById("client-info").style.display = "block";
            if (this.value === "new") {
                $('#audit_record_company_name').val('')
                $('#audit_record_company_address').val('')
                $('#audit_record_exterior_number').val('')
                $('#audit_record_interior_number').val('')
                $('#audit_record_suburb').val('')
                $('#audit_record_postal_code').val('')
                $('#audit_record_state_id').val('')
                $('#audit_record_mayoralty').val('')
                $('#audit_record_municipality').val('')
                $('#audit_record_website').val('')
                $('#audit_record_name').val('')
                $('#audit_record_paternal_last_name').val('')
                $('#audit_record_email').val('')
                $('#audit_record_person_kind').val('')
                $('#audit_record_rfc').val('')
                $('#audit_record_reference_number').val('')
                document.getElementById('tipo_persona').textContent = "Nuevo Cliente";
            } else {
                $.ajax({
                    type: 'GET',
                    url: '/get_client_data/' + this.value,
                    success: function (response) {
                        $('#audit_record_company_name').val(response.company_name)
                        $('#audit_record_company_address').val(response.company_address)
                        $('#audit_record_exterior_number').val(response.exterior_number)
                        $('#audit_record_interior_number').val(response.interior_number)
                        $('#audit_record_suburb').val(response.suburb)
                        $('#audit_record_postal_code').val(response.postal_code)
                        $('#audit_record_state_id').val(response.state_id)
                        $('#audit_record_mayoralty').val(response.mayoralty)
                        $('#audit_record_municipality').val(response.municipality)
                        $('#audit_record_website').val(response.website)
                        $('#audit_record_name').val(response.first_name)
                        $('#audit_record_paternal_last_name').val(response.last_name)
                        $('#audit_record_maternal_last_name').val(response.second_last_name)
                        $('#audit_record_email').val(response.email)
                        $('#audit_record_phone').val(response.phone)
                        $('#audit_record_person_kind').val(response.person_kind)
                        $('#audit_record_rfc').val(response.rfc)
                        $('#audit_record_reference_number').val(response.reference_number)

                        // console.log("responseresponseresponseresponseresponse")
                        // console.log(response)

                        if (response.person_kind === "persona_fisica") {
                            document.getElementById('tipo_persona').textContent = "Persona Física";
                        } else {
                            document.getElementById('tipo_persona').textContent = "Persona Moral";
                        }
                    }
                });
            }
        });

        if (document.getElementById("audit_record_client_id").value !== '') {
            document.getElementById("client-info").style.display = "block";

            if (document.getElementById("audit_record_person_kind").value === "persona_fisica") {
                document.getElementById('tipo_persona').textContent = "Persona Física";
            } else {
                document.getElementById('tipo_persona').textContent = "Persona Moral";
            }

            if (document.getElementById("audit_record_client_id").value !== '') {
                document.getElementById("client-info").style.display = "block";
            }
        }
    }


    const btn = document.getElementById('change-status-btn');
    if (!btn) return;

    btn.addEventListener('click', async (e) => {
        e.preventDefault();

        console.log("btnnnnnnnn");

        const nextStatuses = JSON.parse(btn.dataset.nextStatuses || '[]');
        const auditRecordId = btn.dataset.auditRecordId;
        const requiredField = btn.dataset.requiredField;

        if (nextStatuses.length === 0) {
            Swal.fire('Este estatus no tiene siguientes opciones.','','error');
            return;
        }

        if (requiredField !== '') {
            Swal.fire('¡Error!', requiredField, 'error');
            return;
        }

        const inputOptions = {};
        nextStatuses.forEach(status => {
            inputOptions[status.id] = status.name;
        });

        const { value: selectedStatusId } = await Swal.fire({
            icon: 'info',
            title: 'Selecciona el siguiente estatus',
            input: 'select',
            inputOptions,
            inputPlaceholder: 'Selecciona una opción',
            showCancelButton: true,
            confirmButtonText: 'Actualizar',
            cancelButtonText: 'Cancelar'
        });

        if (selectedStatusId) {
            fetch(`/audit_records/${auditRecordId}/change_status`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify({ next_status_id: selectedStatusId })
            }).then(response => {
                if (response.ok) {
                    Swal.fire('¡Actualizado!', 'El estatus fue cambiado correctamente.', 'success')
                        .then(() => $('#idForm').trigger('submit'));
                } else {
                    Swal.fire('Error', 'No se pudo actualizar el estatus.', 'error');
                }
            });
        }
    });

});
